var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"pay-method-item"},[_c('img',{staticClass:"lazy",style:({
      'border':
        _vm.checked
        ? '2px solid rgba(255,59,0,.93)'
        :'none'
    }),attrs:{"alt":"Pay Image","data-src":_vm.input.imgUrl}}),_vm._v(" "),_c('input',{attrs:{"type":"radio","name":"radio"},domProps:{"checked":_vm.checked,"value":_vm.input.value},on:{"change":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }